import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { sendToVercelAnalytics } from './vitals';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';  // ✅ Import ChakraProvider
import TimerSetup from './TimerPage';
import Timer from './components/Timer';
import NewYearCountdownPage from './NewYearCountdownPage';

ReactDOM.render(
  <React.StrictMode>
    <ChakraProvider>  {/* ✅ Wrap the app with ChakraProvider */}
      <Router>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/timer" element={<TimerSetup />} />
          <Route path="/countdown" element={<Timer />} />
          <Route path="/newyear" element={<NewYearCountdownPage />} />
        </Routes>
      </Router>
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals(sendToVercelAnalytics);
